import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';

import RecurringOrderCard from 'components/orders/RecurringOrderCard/container';

export default styled(RecurringOrderCard)`
  display: flex;
  flex: 1;
  justify-items: flex-start;
  list-style: none;
  background-color: var(--white);
  padding: ${gridSizes('M')};
  position: relative;
  cursor: pointer;
  border: 1px solid var(--grey300);
  margin: 16px 0;
  border-radius: 8px;
  box-shadow: 0px 1px 6px 0px rgb(0 0 0 / 27%);

  &:hover {
    background-color: rgba(240, 242, 246, 0.5);
  }
  ${media.lessThan('extraSmall')`
    display: flex;
    flex-direction: column;
    margin: ${gridSizes('S')} 0;
    padding: ${gridSizes('M')} 0;
  `};

  .recurrent-icon {
    width: 32px;
    height: 32px;
    background-color: #f0f2f6;
    border-radius: 32px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
  }

  .info {
    flex: 1;
    max-width: 510px;
    padding-left: ${gridSizes('M')};
    .schedule {
      margin-top: ${gridSizes('XS')};
      color: var(--grey700);
    }
    p {
      margin: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      b {
        font-style: normal;
        font-weight: ${weights('medium')};
      }
    }
  }

  .status {
    width: 100%;
    text-align: right;
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: var(--grey700);
  }
`;
